<template>
	<div class="independent-wrapper">
		<div class="content">
			<div class="title">
				<span class="border"></span>
				<i class="el-icon-location-outline"></i> 知识库管理 > 运动健康
			</div>
			<div class="contentLeft">
				<div class="tab-container tab">
					<ul>
						<li v-for="(item, index) in tabList" :key="index" :class="{ active: currentTabIndex == index }"
							@click="goOther(index, item.id)">
							{{ item.name }}
						</li>
					</ul>
				</div>
				<div class="con">
					<div class="search-con">
						<el-form :inline="true" :model="searchData" class="demo-form-inline">
							<el-form-item class="el-form-item-line" label="类型">
								<el-select v-model="searchData.type" @change="changeType" placeholder="请选择类型">
									
									<el-option v-for="(item, index) in typeList" :key="index" :label="item.label"
										:value="item.label">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item class="el-form-item-line" style="margin-left: 10px;">
								<el-input class="longInput" v-model="searchData.name" placeholder="输入关键字查询"></el-input>
							</el-form-item>
							<el-form-item class="el-form-item-line" style="margin-left: 10px;">
								<el-button size="large"  @click="reset">
									<el-icon class="el-icon--right"><RefreshRight /></el-icon>
									重置
								</el-button> 
								<el-button size="large"  class="addBtn" @click="add">新增</el-button>
								<el-button size="large"  class="searchBtn" @click="searchPluse">
									<el-icon class="el-icon--right"><Search /></el-icon>
									查询
								</el-button>
							</el-form-item>
						</el-form>
					</div>
					<div class="table-con consiliaTable">
						<el-table ref="multipleTable" :header-cell-style="{ background: '#f7f7f7', color: '#333' }"
							tooltip-effect="dark" style="width: 100%" :data="tableListData">
							<el-table-column align="center" label="序号" prop="seq" width="80">
							</el-table-column>
							<el-table-column align="center" label="类型" prop="type">
							</el-table-column>
							<el-table-column align="center" label="名称" prop="name">
							</el-table-column>
							<el-table-column align="center" label="操作" width="100">
								<template #default="{row}">
									<span class="editor" @click="edit(row)">
										编辑
									</span>
									<span class="del" @click="del(row)">
										删除
									</span>
								</template>
							</el-table-column>
						</el-table>
						<div class="des">
							<div class="right" style="margin-right: 0;">
								<div class="page">
									<el-pagination @current-change="handleCurrentChange" :current-page="currentPage"
										layout="prev, pager, next, jumper" :total="total" :page-size="10">
									</el-pagination>
								</div>
								<div class="data">
									共
									<span>{{ pages }}</span>页/ <span>{{ total }}</span>条记录
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="dialog">
			<el-dialog :title="addOrEdit == 'add' ? '新增运动健康' : '编辑运动健康'" v-model="addUserFlag" center>
				<div class="con">
					<el-form ref="addUserForm" :model="addUserForm" :rules="rules" label-width="80px">
						<div class="item">
							<div class="line">
								<el-form-item class="el-form-item-line" label="类型" prop="type">
									<el-select :disabled="addOrEdit == 'edit'" @change="changeAddUserFormType"
										v-model="addUserForm.type" placeholder="请选择类型">
										<el-option v-for="(item, index) in typeList" :key="index" :label="item.label"
											:value="item.label">
										</el-option>
									</el-select>
								</el-form-item>
								<div v-if="addUserForm.type == '保健操'">
									<el-form-item label="名称" prop="name">
										<el-input class="longInput" v-model="addUserForm.name"></el-input>
									</el-form-item>
									<el-form-item label="动作拆解" prop="action">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
											class="longInput" v-model="addUserForm.action"></el-input>
									</el-form-item>
								</div>
								<div v-if="addUserForm.type == '传统功法'">
									<el-form-item label="名称" prop="name">
										<el-input style="width: auto;" class="longInput" v-model="addUserForm.name">
										</el-input>
										<span>（支持输入多个功法名称，中间用逗号隔开）</span>
									</el-form-item>
									<el-form-item label="原则" prop="principle">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
											class="longInput" v-model="addUserForm.principle"></el-input>
									</el-form-item>
									<el-form-item label="功效" prop="effect">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
											class="longInput" v-model="addUserForm.effect"></el-input>
									</el-form-item>
									<el-form-item label="时间" prop="time">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
											class="longInput" v-model="addUserForm.time"></el-input>
									</el-form-item>
									<el-form-item label="宜忌" prop="guide">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
											class="longInput" v-model="addUserForm.guide"></el-input>
									</el-form-item>
								</div>
								<div v-if="addUserForm.type == '运动'">
									<el-form-item label="名称" prop="name">
										<el-input class="longInput" v-model="addUserForm.name"></el-input>
									</el-form-item>
									<el-form-item label="原则" prop="principle">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
											class="longInput" v-model="addUserForm.principle"></el-input>
									</el-form-item>
									<el-form-item label="功效" prop="effect">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
											class="longInput" v-model="addUserForm.effect"></el-input>
									</el-form-item>
									<el-form-item label="时间" prop="time">
										<el-input class="longInput" v-model="addUserForm.time"></el-input>
									</el-form-item>
									<el-form-item label="宜忌" prop="guide">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
											class="longInput" v-model="addUserForm.guide"></el-input>
									</el-form-item>
								</div>
								<el-form-item label="图片" prop="pic">
									<el-autocomplete  popper-class="my-autocomplete" v-model="addUserForm.pic"
										:fetch-suggestions="querySearch" placeholder="请输入内容" @select="handleSelect">
										<template #prefix>
										    <el-icon class="el-input__icon"><Search></Search></el-icon>
										</template>
										<template #default="{item}">
											<div class="img">
												<img :src="globalImageUrl + item.path" />
												<span class="name">{{ item.name }}</span>
											</div>
										</template>
									</el-autocomplete>
									<span class="more" style="margin-left: 10px;color: #999;">最多可选3张</span>
								</el-form-item>
								<div class="select" v-if="selectedPicList.length > 0">
									<ul class="select-ul">
										<li v-for="(item, index) in selectedPicList" :key="index">
											<div class="path">
												<img :src="globalImageUrl + item.path" />
											</div>
											<span class="name">{{ item.name }}</span>
										</li>
									</ul>
									<ul class="selected-ul">
										<span class="span">已选择的图片：</span>
										<div class="li">
											<li v-for="(item, index) in selectedPicList" :key="index">
												<span class="name">{{ item.name }}</span>
												<i @click="handleClose(item)" class="el-icon-circle-close">
													<CircleClose style="width:14px;float: left;margin-top: 8px;"></CircleClose>
												</i>
											</li>
										</div>
									</ul>
								</div>
								<el-form-item style="display: none;" class="el-form-item-line" label="视频" prop="video">
									<el-select @change="selectVideo" filterable v-model="addUserForm.videoId"
										placeholder="请选择视频">
										<el-option v-for="item in videoList" :key="item.title" :label="item.title"
											:value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
							</div>
						</div>
					</el-form>
				</div>
				<template class="dialog-footer" #footer>
					<el-button size="large" @click="cancelPatient">取 消</el-button>
					<el-button size="large" class="addBtn" type="primary" @click="addPatient('addUserForm')">确 定</el-button>
				</template>
			</el-dialog>
		</div>
	</div>
</template>
<script>
	import globle from "../../globle/globle";
	import { RefreshRight,Search } from '@element-plus/icons-vue'
	export default {
		data() {
			return {
				RefreshRight,
				Search,
				total: 0,
				currentPage: 1,
				pages: 1,
				role: "",
				tabList: [{
						id: 0,
						name: "饮食推荐",
					},
					{
						id: 1,
						name: "体质管理",
					},
					{
						id: 2,
		 			name: "选项维护",
					},
					{
						id: 3,
						name: "健康评估",
					},
					{
						id: 4,
						name: "穴位维护",
					},
					{
						id: 5,
						name: "运动健康",
					},
					{
						id: 6,
						name: "药食管理",
					},
					{
						id: 7,
						name: "图片管理",
					},
					{
						id: 8,
						name: "视频管理",
					},
				],
				currentTabIndex: 5,
				searchData: {
					name: "", //脉诊结果
					type: "传统功法",
				},
				fileData: null, //文件
				fileList: [],
				fileObj: null,
				tableListData: [],
				pulseList: [],
				addUserForm: {
					type: "传统功法",
					name: "",
					action: "", //动作拆解
					principle: "", //原则
					effect: "", //'功效'
					time: "", //时间
					guide: "", //宜禁
					pic: "", //选择的图片
					videoId: "",
					id: "",
				},
				addOrEdit: "",
				addUserFlag: false,
				globalImageUrl: globle.imgPath,
				picList: [],
				selectedPicList: [], //被选中的图片
				isAcupointFlag: false, //是否为穴位
				isChineseMedicineFlag: false, //是否为中成药
				typeList: [{
						label: "保健操",
						id: "1",
					},
					{
						label: "传统功法",
						id: "0",
					},
					{
						label: "运动",
						id: "2",
					},
				],
				dosageTypeList: [{
						label: "丸",
						id: "0",
					},
					{
						label: "其他剂型",
						id: "1",
					},
				],
				videoList: [],
				selectVideoList: [],
				changeTypeName: "",
			};
		},

		computed: {
			rules() {
				const base = {
					type: [{ required: true, message: "请选择类型", trigger: "change" }],
					name: [{ required: true, message: "请输入名称", trigger: "blur" }],
				};
				if (this.addUserForm.type == "保健操") {
					base.action = [{ required: true, message: "请输入动作拆解", trigger: "blur" }];
				} else if (this.addUserForm.type == "传统功法") {
					base.principle = [{ required: true, message: "请输入原则", trigger: "blur" }];
					base.effect = [{ required: true, message: "请输入功效", trigger: "blur" }];
					base.time = [{ required: true, message: "请输入时间", trigger: "blur" }];
					base.guide = [{ required: true, message: "请输入宜忌", trigger: "blur" }];
				}
				// 运动: 仅 name 必填
				return base;
			},
		},
		methods: {
			//路由切换
			goOther(index, id) {
				this.currentTabIndex = index;
				if (index == 0) {
					this.$router.push({
						path: "/knowledgeManagement/dietRecommend",
					});
				}
				if (index == 1) {
					this.$router.push({
						path: "/knowledgeManagement/constituteManagement",
					});
				}
				if (index == 2) {
					this.$router.push({
						path: "/knowledgeManagement/optionManagement",
					});
				}
				if (index == 3) {
					this.$router.push({
						path: "/knowledgeManagement/healthAssessment",
					});
				}
				if (index == 4) {
					this.$router.push({
						path: "/knowledgeManagement/physiothMainten",
					});
				}
				if (index == 5) {
					this.$router.push({
						path: "/knowledgeManagement/sportsHealth",
					});
				}
				if (index == 6) {
					this.$router.push({
						path: "/knowledgeManagement/drugManagement",
					});
				}
				if (index == 7) {
					this.$router.push({
						path: "/knowledgeManagement/picManagement",
					});
				}
				if (index == 8) {
					this.$router.push({
						path: "/knowledgeManagement/videoManagement",
					});
				}
			},
			//重置
			reset() {
				this.searchData = {
					name: "", //脉诊结果
					type: "传统功法",
				}
				this.searchPluse();
			},
			//新增脉象
			add() {
				this.addUserFlag = true;
				this.addUserForm.type = this.searchData.type || "传统功法";
				this.addUserForm.name = "";
				this.addUserForm.action = "";
				this.addUserForm.pic = "";
				this.addUserForm.id = "";
				this.addUserForm.effect = "";
				this.addUserForm.principle = "";
				this.addUserForm.time = "";
				this.addUserForm.guide = "";
				this.addUserForm.id = "";
				this.selectedPicList = [];
				this.selectVideoList = [];
				this.addOrEdit = "add";
				this.$nextTick(() => {
					this.$refs.addUserForm.clearValidate();
				});
			},
			//编辑脉象
			edit(item) {
				this.addOrEdit = "edit";
				this.addUserForm.type = item.type;
				if (this.addUserForm.type == "保健操") {
					this.getExercisesDetail(item.id);
				} else if (this.addUserForm.type == "运动") {
					this.getSportDetail(item.id);
				} else {
					this.getTraditionalDetail(item.id);
				}
			},
			//获取保健操详情
			getExercisesDetail(id) {
				this.$applicationJson("/business/base/exercises/detail", {
						id: id,
					})
					.then((res) => {
						if (res.data.code == 0) {
							let item = res.data.data;

							this.addUserForm.name = item.name;
							this.addUserForm.id = item.id;
							this.addUserForm.action = item.action;
							this.addUserFlag = true;
							if (item.images) {
								this.selectedPicList = item.images;
							}
							this.$nextTick(() => {
								this.$refs.addUserForm.clearValidate();
							});
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//获取保健操详情
			getTraditionalDetail(id) {
				this.$applicationJson("/business/base/traditional/exercises/detail", {
						id: id,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							let item = res.data.data;
							this.addUserForm.name = item.name;
							this.addUserForm.id = item.id;
							this.addUserForm.effect = item.effect;
							this.addUserForm.principle = item.principle;
							this.addUserForm.time = item.time;
							this.addUserForm.guide = item.guide;
							this.addUserFlag = true;
							if (item.images) {
								this.selectedPicList = item.images;
							}
							/* if(item.videos){
								if(item.videos.length>0){
									this.addUserForm.videoId = item.videos[0].id;
									this.selectVideoList = item.videos;
								}					
							}	 */

							this.$nextTick(() => {
								this.$refs.addUserForm.clearValidate();
							});
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//删除脉象
			del(item) {
				this.$confirm("此操作将删除该条记录, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
					})
					.then(() => {
						if (this.searchData.type == "保健操") {
							this.delExercises(item.id);
						}
						if (this.searchData.type == "传统功法") {
							this.delTraditionalExercises(item.id);
						}
						if (this.searchData.type == "运动") {
							this.delSport(item.id);
						}
					})
					.catch(() => {});
			},
			//取消
			cancelPatient() {
				this.addUserFlag = false;
			},
			//确定
			addPatient(formName) {
				//this.$forceUpdate();
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.addOrEdit == "add" && this.addUserForm.type == "保健操") {
							this.addExercises(); //新增保健操
						}
						if (this.addOrEdit == "add" && this.addUserForm.type == "传统功法") {
							this.addTraditionalExercises(); //新增传统功法
						}
						if (this.addOrEdit == "add" && this.addUserForm.type == "运动") {
							this.addSport(); //新增运动
						}

						if (this.addOrEdit == "edit" && this.addUserForm.type == "保健操") {
							this.editExercises();
						}
						if (this.addOrEdit == "edit" && this.addUserForm.type == "传统功法") {
							this.editTraditionalExercises();
						}
						if (this.addOrEdit == "edit" && this.addUserForm.type == "运动") {
							this.editSport();
						}

						this.currentPage = 0;
					} else {
						return false;
					}
				});
			},
			//新增保健操
			addExercises() {
				this.$applicationJson("/business/base/exercises/add", {
						type: this.addUserForm.type,
						name: this.addUserForm.name,
						createTime: "",
						action: this.addUserForm.action,
						images: this.selectedPicList,
						videos: this.selectVideoList,
						id: "",
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.addUserFlag = false;
						}
						if (this.changeTypeName == "保健操") {
							this.getExercisesList(0);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//编辑其它接口
			editExercises() {
				this.$applicationJson("/business/base/exercises/edit", {
						type: this.addUserForm.type,
						name: this.addUserForm.name,
						createTime: this.addUserForm.createTime,
						action: this.addUserForm.action,
						images: this.selectedPicList,
						videos: this.selectVideoList,
						id: this.addUserForm.id,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.addUserFlag = false;
						}
						this.getExercisesList(0);
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//删除
			delExercises(id) {
				let ids = [];
				ids.push(id);
				this.$applicationJson("/business/base/exercises/delete", {
						ids: ids,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.$message({
								type: "success",
								message: "删除成功!",
							});
						}
						this.getExercisesList(0);
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//新增传统功法
			addTraditionalExercises() {
				this.$applicationJson("/business/base/traditional/exercises/add", {
						type: this.addUserForm.type,
						name: this.addUserForm.name,
						createTime: "",
						effect: this.addUserForm.effect,
						principle: this.addUserForm.principle,
						time: this.addUserForm.time,
						guide: this.addUserForm.guide,
						images: this.selectedPicList,
						videos: this.selectVideoList,
						id: "",
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.addUserFlag = false;
						}
						if (this.changeTypeName == "传统功法") {
							this.getTraditionalExercisesList(0);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//编辑其它接口
			editTraditionalExercises() {
				this.$applicationJson("/business/base/traditional/exercises/edit", {
						type: this.addUserForm.type,
						name: this.addUserForm.name,
						createTime: this.addUserForm.createTime,
						effect: this.addUserForm.effect,
						principle: this.addUserForm.principle,
						time: this.addUserForm.time,
						guide: this.addUserForm.guide,
						images: this.selectedPicList,
						videos: this.selectVideoList,
						id: this.addUserForm.id,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.addUserFlag = false;
						}
						this.getTraditionalExercisesList(0);
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//删除
			delTraditionalExercises(id) {
				let ids = [];
				ids.push(id);
				this.$applicationJson("/business/base/traditional/exercises/delete", {
						ids: ids,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.$message({
								type: "success",
								message: "删除成功!",
							});
						}
						this.getTraditionalExercisesList(0);
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//页码跳转
			handleCurrentChange(val) {
				this.currentPage = val;
				if (this.searchData.type == "保健操") {
					this.getExercisesList(this.currentPage);
				} else if (this.searchData.type == "运动") {
					this.getSportList(this.currentPage);
				} else {
					this.getTraditionalExercisesList(this.currentPage);
				}
			},
			//搜索
			searchPluse() {
				if (this.searchData.type == "保健操") {
					this.getExercisesList(0);
				} else if (this.searchData.type == "运动") {
					this.getSportList(0);
				} else {
					this.getTraditionalExercisesList(0);
				}
			},
			//获取保健操列表
			getExercisesList(currentPage) {
				this.$applicationJson("/business/base/exercises/paging", {
						current: currentPage,
						orderBy: "",
						params: {
							name: this.searchData.name,
							type: this.searchData.type,
						},
						size: 10,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.tableListData = res.data.data.records;
							for (let i = 0; i < this.tableListData.length; i++) {
								this.tableListData[i].seq = Number(i) + 1;
							}
							this.total = res.data.data.total;
							this.pages = res.data.data.pages;
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//获取传统功法列表
			getTraditionalExercisesList(currentPage) {
				this.$applicationJson("/business/base/traditional/exercises/paging", {
						current: currentPage,
						orderBy: "",
						params: {
							name: this.searchData.name,
							type: this.searchData.type,
						},
						size: 10,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.tableListData = res.data.data.records;
							for (let i = 0; i < this.tableListData.length; i++) {
								this.tableListData[i].seq = Number(i) + 1;
							}
							this.total = res.data.data.total;
							this.pages = res.data.data.pages;
							//this.currentPage = 0;
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//获取运动列表
			getSportList(currentPage) {
				this.$applicationJson("/business/base/sport/paging", {
						current: currentPage,
						orderBy: "",
						params: {
							name: this.searchData.name,
							type: this.searchData.type,
						},
						size: 10,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.tableListData = res.data.data.records;
							for (let i = 0; i < this.tableListData.length; i++) {
								this.tableListData[i].seq = Number(i) + 1;
							}
							this.total = res.data.data.total;
							this.pages = res.data.data.pages;
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//获取运动详情
			getSportDetail(id) {
				this.$applicationJson("/business/base/sport/detail", {
						id: id,
					})
					.then((res) => {
						if (res.data.code == 0) {
							let item = res.data.data;
							this.addUserForm.name = item.name;
							this.addUserForm.id = item.id;
							this.addUserForm.principle = item.principle;
							this.addUserForm.effect = item.effect;
							this.addUserForm.time = item.time;
							this.addUserForm.guide = item.guide;
							this.addUserFlag = true;
							if (item.images) {
								this.selectedPicList = item.images;
							}
							this.$nextTick(() => {
								this.$refs.addUserForm.clearValidate();
							});
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//新增运动
			addSport() {
				this.$applicationJson("/business/base/sport/add", {
						type: this.addUserForm.type,
						name: this.addUserForm.name,
						principle: this.addUserForm.principle,
						effect: this.addUserForm.effect,
						time: this.addUserForm.time,
						guide: this.addUserForm.guide,
						images: this.selectedPicList,
						videos: this.selectVideoList,
						id: "",
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.addUserFlag = false;
						}
						if (this.changeTypeName == "运动" || this.searchData.type == "运动") {
							this.getSportList(0);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//编辑运动
			editSport() {
				this.$applicationJson("/business/base/sport/edit", {
						type: this.addUserForm.type,
						name: this.addUserForm.name,
						principle: this.addUserForm.principle,
						effect: this.addUserForm.effect,
						time: this.addUserForm.time,
						guide: this.addUserForm.guide,
						images: this.selectedPicList,
						videos: this.selectVideoList,
						id: this.addUserForm.id,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.addUserFlag = false;
						}
						this.getSportList(0);
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//删除运动
			delSport(id) {
				let ids = [];
				ids.push(id);
				this.$applicationJson("/business/base/sport/delete", {
						ids: ids,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.$message({
								type: "success",
								message: "删除成功!",
							});
						}
						this.getSportList(0);
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//获取图片列表
			getImageList(currentPage) {
				this.$applicationJson("/business/base/image/paging", {
						current: currentPage,
						orderBy: "",
						params: {
							name: "",
						},
						size: 1000,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.picList = res.data.data.records;
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			querySearch(queryString, cb) {
				var picList = this.picList;
				var results = queryString ?
					picList.filter(this.createFilter(queryString)) :
					picList;
				// 调用 callback 返回建议列表的数据
				cb(results);
			},
			//图片搜索
			createFilter(queryString) {
				return (picList) => {
					return (
						picList.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0
					);
				};
			},
			//图片选择
			handleSelect(item) {
				this.selectedPicList.push(item);
				if (this.selectedPicList.length == 2) {
					return false;
				}
			},
			//选择视频
			selectVideo(id) {
				this.selectVideoList = [];
				for (let i = 0; i < this.videoList.length; i++) {
					if (this.videoList[i].id == id) {
						this.selectVideoList.push(this.videoList[i]);
					}
				}
			},
			//图片关闭
			handleClose(tag) {
				this.selectedPicList.splice(this.selectedPicList.indexOf(tag), 1);
			},
			//搜索切换类型
			changeType(val) {
				this.changeTypeName = val;
				if (val == "保健操") {
					this.getExercisesList(0);
				} else if (val == "运动") {
					this.getSportList(0);
				} else {
					this.getTraditionalExercisesList(0);
				}

				this.currentPage = 0;
			},
			//获取视频列表
			getVideoList(page) {
				this.$applicationJson("/business/shutcm/video/paging", {
						orderBy: null,
						orderType: 1, //0正序  1倒序
						page: 0,
						pageSize: 100,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.videoList = res.data.data.records;
						}
					})
					.catch((Error) => {
						//this.$message.error('网络异常');
					});
			},
			//新增修改切换类型
			changeAddUserFormType(val) {
				/* this.addUserForm.name = '';
				this.addUserForm.rawMaterial = '';
				this.addUserForm.preparateMethod = '';
				this.addUserForm.usage = '';
				this.addUserForm.pic = '';
				this.addUserForm.acupointPosition = '';
				this.addUserForm.meridians = '';
				this.addUserForm.acupointOperation = '';
				//alert(val)
				if (val == '穴位') {
					this.isAcupointFlag = true;
					this.isChineseMedicineFlag = false;					
					this.searchData.type = "穴位";
					this.$refs.addUserForm.clearValidate('name')
					this.$refs.addUserForm.clearValidate('rawMaterial')
					this.$refs.addUserForm.clearValidate('preparateMethod')
					this.$refs.addUserForm.clearValidate('usage')
				}
				if(val == '中成药'){
					this.isChineseMedicineFlag = true;
					this.isAcupointFlag = false;
					this.searchData.type = "中成药";
				}
				else {
					this.isAcupointFlag = false;
					this.isChineseMedicineFlag = false;					
					this.searchData.type = "";
					this.$refs.addUserForm.clearValidate('name')
					this.$refs.addUserForm.clearValidate('acupointPosition')
					this.$refs.addUserForm.clearValidate('meridians')
					this.$refs.addUserForm.clearValidate('acupointOperation')
				} */
			},
		},
		created() {
			this.$nextTick(() => {
				let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
				let role = loginInfo.role;
				this.role = role;
				if (role == 1) {
					this.tabList.splice(0, 5);
				}
				this.getImageList(0);
				this.getVideoList();
				this.getTraditionalExercisesList(0);
			});
		},
	};
</script>

<style lang="less" scoped="scoped">
	@import "../../../static/css/layout.less";
	@import "../../../static/css/mentor.less";

	.independent-wrapper {
		.content {
			.contentLeft {
				width: 100%;
				height: calc(100% - 40px);

				.con {
					min-height: calc(100% - 80px);

					.search-con {
						height: 120px;
						@media screen and (min-width: 1076px) and (max-width: 1920px) {
							height: 60px;
							width: 100%;
						}
					}
				}
			}

			.about {
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				overflow: hidden;
			}

			.demo-form-inline {
				margin-top: 10px;

				:deep(.el-input__inner){
					width: 220px;
				}
			}

			.editor {
				cursor: pointer;
				color: #679ff6;
			}

			.del {
				color: #df6d78;
				cursor: pointer;
				margin-left: 10px;
			}

		}
	}

	.dialog {
		:deep(.el-dialog__body) {
			padding: 0;

			.con {
				margin-top: 30px;
				padding: 0 5px;
				width: calc(100% - 10px);
				overflow-y: auto;
				padding-bottom: 30px;
				min-height: 500px;

				.item {
					.line {
						width: 100%;
						overflow: hidden;

						&:nth-child(1) {
							margin-bottom: 20px;
						}

						.el-form-item {
							width: 100%;
						}

						.dosageIcon {
							font-size: 16px;
							color: #666;
							margin-left: 10px;
							cursor: pointer;
						}

						.dialog-tit {
							height: 40px;
							line-height: 40px;

							span {
								float: left;
								font-size: 16px;
								margin-bottom: 20px;
								overflow: hidden;
								width: 100%;
								color: #333;
							}

							.border {
								background-color: rgba(103, 159, 246, 1);
								width: 3px;
								height: 14px;
								margin-top: 13px;
								position: absolute;
								left: 0px;
							}
						}
					}
				}

				.longInput {
					width: 100%;

					:deep(.el-input__inner){
						width: 100%;
					}
				}

				.smallInput {
					width: 150px;

					:deep(.el-input__inner){
						width: 100%;
					}
				}
			}
		}
	}

	.img {
		margin-bottom: 10px;
		float: left;

		img {
			float: left;
			width: 40px;
		}

		span {
			float: left;
			margin-left: 10px;
			width: calc(100% - 50px);
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			-o-text-overflow: ellipsis;
		}
	}

	.select {
		margin-left: 40px;
		width: calc(100% - 40px);

		ul {
			float: left;
			width: 100%;
			margin-bottom: 20px;

			li {
				float: left;
				width: 120px;
				text-align: center;

				.path {
					img {
						width: 40px;
						margin-left: 40px;
						max-height: 40px;
					}

					width: 40px;
					height: 40px;
				}

				span {
					margin-left: 10px;
					width: calc(100% - 50px);
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
					-o-text-overflow: ellipsis;
					display: inline-block;
				}
			}
		}

		.selected-ul {
			float: left;
			width: 100%;
			margin-left: 40px;

			.span {
				float: left;
				width: 100px;
				line-height: 30px;
			}

			.li {
				float: left;
				width: calc(100% - 110px);

				li {
					border: 1px solid #eee;
					line-height: 30px;
					margin-right: 10px;
					width: auto;
					padding: 0 10px;

					span {
						width: 80px;
						float: left;
						line-height: 30px;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						-o-text-overflow: ellipsis;
					}

					i {
						cursor: pointer;
						margin-left: 8px;
						color: #333;
						float: left;
						line-height: 30px;
					}
				}
			}
		}
	}
</style>
